import { defineMessages } from 'react-intl.macro';

export const monitoringMessages = defineMessages({
  timelineWaiting: {
    id: 'monitoring.timeline.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  timelineFail: {
    id: 'monitoring.timeline.fail',
    defaultMessage: 'Historii se nepovedlo načíst. Zkuste to prosím později.',
  },
  timelineEmpty: {
    id: 'monitoring.timeline.empty',
    defaultMessage: 'Žádné záznamy. Starší historie se neuchovává.',
  },
  timelineShown: {
    id: 'monitoring.timeline.shown',
    defaultMessage: 'Zobrazeno {shown} záznamů z {count}.',
  },
  timelineLoadMore: {
    id: 'monitoring.timeline.loadMore',
    defaultMessage:
      'Zobrazit starší historii ({count, plural, one {# záznam} few {# záznamy} other {# záznamů}})',
  },
  timelineLoadingMore: {
    id: 'monitoring.timeline.loadingMore',
    defaultMessage: 'Načítám starší historii...',
  },
  timelineLoadMoreFailed: {
    id: 'monitoring.timeline.loadMoreFailed',
    defaultMessage: 'Načtení selhalo, zkusit znovu',
  },
  timelineStale: {
    id: 'monitoring.timeline.stale',
    defaultMessage: 'Mezitím přibyly nové záznamy.',
  },
  timelineRefresh: {
    id: 'monitoring.timeline.refresh',
    defaultMessage: 'Načíst znovu',
  },
  updaterNull: {
    id: 'monitoring.updaterNull',
    defaultMessage: 'Systémová změna',
  },
  jobLink: {
    id: 'monitoring.jobLink',
    defaultMessage: 'Job {id}',
  },
  showMessage: {
    id: 'monitoring.showMessage',
    defaultMessage: 'Zobrazit celou zprávu',
  },
  hideMessage: {
    id: 'monitoring.hideMessage',
    defaultMessage: 'Skrýt zprávu',
  },
  recordedAt: {
    id: 'monitoring.recordedAt',
    defaultMessage: 'Zaznamenáno {recorded}',
  },
  eventCount: {
    id: 'monitoring.eventCount',
    defaultMessage: '{count, plural, one {# událost} few {# události} other {# událostí}}',
  },
  errorCount: {
    id: 'monitoring.errorCount',
    defaultMessage: '{count, plural, one {# chyba} few {# chyby} other {# chyb}}',
  },
  warningCount: {
    id: 'monitoring.warningCount',
    defaultMessage: '{count} varování',
  },
  collapseAllDays: {
    id: 'monitoring.collapseAllDays',
    defaultMessage: 'Sbalit vše',
  },
  expandAllDays: {
    id: 'monitoring.expandAllDays',
    defaultMessage: 'Rozbalit vše',
  },
  showOlderStates: {
    id: 'monitoring.showOlderStates',
    defaultMessage:
      'Další {count, plural, one {# změna stavu} few {# změny stavu} other {# změn stavu}}',
  },
  flowChange: {
    id: 'monitoring.flowChange',
    defaultMessage: 'Změna režimu',
  },
  hideOlderStates: {
    id: 'monitoring.hideOlderStates',
    defaultMessage: 'Skrýt starší změny',
  },
});

export const monitoringSourceMessages = defineMessages({
  DMVS: {
    id: 'monitoring.source.DMVS',
    defaultMessage: 'DMVS',
  },
  ISTEM: {
    id: 'monitoring.source.ISTEM',
    defaultMessage: 'ISTEM',
  },
  DESA: {
    id: 'monitoring.source.DESA',
    defaultMessage: 'DESA',
  },
  GEOREAL: {
    id: 'monitoring.source.GEOREAL',
    defaultMessage: 'Georeál',
  },
  UAP: {
    id: 'monitoring.source.UAP',
    defaultMessage: 'ÚAP',
  },
  JOBSCHEDULER: {
    id: 'monitoring.source.JOBSCHEDULER',
    defaultMessage: 'JobScheduler',
  },
  DMX: {
    id: 'monitoring.source.DMX',
    defaultMessage: 'DMX',
  },
  LEGACY: {
    id: 'monitoring.source.LEGACY',
    defaultMessage: 'Přenesená historie',
  },
});

export const monitoringEventTypeMessages = defineMessages({
  CALL: {
    id: 'monitoring.eventType.CALL',
    defaultMessage: 'Volání',
  },
  CALLBACK: {
    id: 'monitoring.eventType.CALLBACK',
    defaultMessage: 'Callback',
  },
  JOB: {
    id: 'monitoring.eventType.JOB',
    defaultMessage: 'Job',
  },
  FLOW: {
    id: 'monitoring.eventType.FLOW',
    defaultMessage: 'Krok procesu',
  },
  LEGACY: {
    id: 'monitoring.eventType.LEGACY',
    defaultMessage: 'Přenesený záznam',
  },
});

export const monitoringDirectionMessages = defineMessages({
  OUT: {
    id: 'monitoring.direction.OUT',
    defaultMessage: 'Odchozí',
  },
  IN: {
    id: 'monitoring.direction.IN',
    defaultMessage: 'Příchozí',
  },
  INTERNAL: {
    id: 'monitoring.direction.INTERNAL',
    defaultMessage: 'Interní',
  },
});

export const monitoringOutcomeMessages = defineMessages({
  ACCEPTED: {
    id: 'monitoring.outcome.ACCEPTED',
    defaultMessage: 'Přijato ke zpracování',
  },
  SUCCEEDED: {
    id: 'monitoring.outcome.SUCCEEDED',
    defaultMessage: 'Dokončeno',
  },
  REJECTED: {
    id: 'monitoring.outcome.REJECTED',
    defaultMessage: 'Odmítnuto',
  },
  FAILED: {
    id: 'monitoring.outcome.FAILED',
    defaultMessage: 'Selhalo',
  },
  CANCELLED: {
    id: 'monitoring.outcome.CANCELLED',
    defaultMessage: 'Zrušeno',
  },
  UNKNOWN: {
    id: 'monitoring.outcome.UNKNOWN',
    defaultMessage: 'Bez výsledku',
  },
});
